import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import { statusRender, statusTypeRender } from "../utils/cellRenderTable";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchAwardList } from "../actions/award";
import { fetchDeleteAward } from "../actions/award";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const AwardList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "rewards";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { awardList } = useSelector((state) => state.awardReducer);

  useEffect(() => {
    dispatch(fetchAwardList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/award-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteAward(pageId));
  };

  const imageRenderer = (params) => {
    if (!params.data || !params.data.image || !params.data.name) return null;
    return (
      <img
        src={params.data.image}
        alt={params.data.name}
        className="image-aggrid-cell"
      />
    );
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("awardList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.image"),
      field: "image",
      width: 130,
      cellRenderer: imageRenderer,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.points"),
      field: "points",
      filter: "agTextColumnFilter",
      minWidth: 100,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.levelName"),
      field: "levelName",
      filter: "agSetColumnFilter",
      minWidth: 150,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: "Tip nagrade",
      field: "type",
      filter: "agSetColumnFilter",
      cellRenderer: statusTypeRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.type) return null;
        return t(`awardList.${params.data.type}`);
      },
      width: 250,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        return t(`awardList.${params.data.status}`);
      },
      width: 150,
      cellStyle: { display: "flex", alignItems: "center" },
    },
    {
      headerName: t("awardList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      cellStyle: { display: "flex", alignItems: "center" },
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("awardList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      cellStyle: { display: "flex", alignItems: "center" },
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
      cellStyle: { display: "flex", alignItems: "center" },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={awardList}
        columnDefs={columnDefs}
        rowHeight={60}
        buttonLink={`/award-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"award-list"}
      />
    </Fragment>
  );
};

export default AwardList;
